import { initializeApp } from 'firebase/app';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { firebaseConfig } from './firebaseConfig';


export const app = initializeApp(firebaseConfig);

// Firestore configured with long-polling to avoid WebSocket CORS issues on mobile Safari
// This uses HTTPS instead of WebSockets for compatibility.
// persistentLocalCache keeps documents in IndexedDB, so after the first launch
// hospitals and education content render instantly (and offline) while fresh
// data syncs in the background.
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  experimentalAutoDetectLongPolling: false,
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

export const storage = getStorage(app);
export const auth = getAuth(app);
export const functions = getFunctions(app);

// Initialize Analytics (only in supported environments)
let analyticsInstance = null;

// Check if analytics is supported and initialize
(async () => {
  const supported = await isSupported();
  if (supported) {
    analyticsInstance = getAnalytics(app);
    console.log('✅ Firebase Analytics initialized');
  } else {
    console.log('ℹ️ Analytics not supported in this environment');
  }
})();

export const getAnalyticsInstance = () => analyticsInstance;
export const analytics = analyticsInstance;